const propertiesApi = ({ apiClient }) => ({
  delete(id, headers = {}) {
    return apiClient.delete(`properties/${id}`, headers)
  },

  store(payload) {
    return apiClient.post('properties', payload, false, {})
  },
  duplicate(id, headers = {}) {
    return apiClient.post(`properties/${id}/duplicate`, {}, false, headers)
  },

  update(id, payload) {
    return apiClient.put(`properties/${id}`, payload, {})
  },

  list(params, headers = {}) {
    return apiClient.get(
      'properties',
      {},
      {
        ...params,
      },
      headers,
    )
  },

  formOptions(params = {}, headers = {}) {
    return apiClient.get('properties/form-options', {}, params, headers)
  },

  show(id, param = {}) {
    return apiClient.get(`properties/${id}`, {}, param, {})
  },

  amenities(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/amenities`, {}, params, headers)
  },

  amenityGroups(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/amenity-groups`, {}, params, headers)
  },

  addresses(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/addresses`, {}, params, headers)
  },

  metadata(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/metadata`, {}, params, headers)
  },

  referencePoints(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/reference-points`, {}, params, headers)
  },

  condominium(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/condominium`, {}, params, headers)
  },

  propertyType(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/property-type`, {}, params, headers)
  },

  seo(id, params = {}, headers = {}) {
    return apiClient.get(`properties/${id}/seo`, {}, params, headers)
  },

  photos: {
    listByIds(params = {}, headers = {}) {
      return apiClient.get('properties/photos', {}, params, headers)
    },

    list(propertyId, params = {}, headers = {}) {
      return apiClient.get(`properties/${propertyId}/photos`, {}, params, headers)
    },

    listByType(propertyId, type, params = {}, headers = {}) {
      return apiClient.get(`properties/${propertyId}/photos/type/${type}`, {}, params, headers)
    },

    show(propertyId, photoId, params = {}, headers = {}) {
      return apiClient.get(`properties/${propertyId}/photos/${photoId}`, {}, params, headers)
    },

    store(propertyId, payload, headers = {}) {
      return apiClient.post(`properties/${propertyId}/photos`, payload, false, headers)
    },

    update(propertyId, photoId, payload, headers = {}) {
      return apiClient.put(`properties/${propertyId}/photos/${photoId}`, payload, headers)
    },

    patch(propertyId, photoId, payload, headers = {}) {
      return apiClient.patch(`properties/${propertyId}/photos/${photoId}`, payload, headers)
    },

    delete(propertyId, photoId, headers = {}) {
      return apiClient.delete(`properties/${propertyId}/photos/${photoId}`, headers)
    },
  },

  videos: {
    list(propertyId, params = {}, headers = {}) {
      return apiClient.get(`properties/${propertyId}/videos`, {}, params, headers)
    },

    show(propertyId, videoId, params = {}, headers = {}) {
      return apiClient.get(`properties/${propertyId}/videos/${videoId}`, {}, params, headers)
    },

    store(propertyId, payload, headers = {}) {
      return apiClient.post(`properties/${propertyId}/videos`, payload, false, headers)
    },

    update(propertyId, videoId, payload, headers = {}) {
      return apiClient.put(`properties/${propertyId}/videos/${videoId}`, payload, headers)
    },

    patch(propertyId, videoId, payload, headers = {}) {
      return apiClient.patch(`properties/${propertyId}/videos/${videoId}`, payload, headers)
    },

    delete(propertyId, videoId, headers = {}) {
      return apiClient.delete(`properties/${propertyId}/videos/${videoId}`, headers)
    },
  },

  types(params) {
    return apiClient.get('properties/types', {}, params)
  },

  typeById(id, params) {
    return apiClient.get(`properties/types/by-id/${id}`, {}, params)
  },

  storeTypes(payload,) {
    return apiClient.post('properties/types', payload, false, {})
  },

  updateTypes(id, params) {
    return apiClient.put(`properties/types/${id}`, params, {})
  },

  deleteTypes(id, params) {
    return apiClient.delete(`properties/types/${id}`, {}, params)
  },

  neighborhoods(params, headers = {}) {
    return apiClient.get(
      'properties',
      {},
      {
        use_resource: 'neighborhoods',
        ...params,
      },
      headers,
    )
  },

  cities(params, headers = {}) {
    return apiClient.get(
      'properties',
      {},
      {
        use_resource: 'cities',
        ...params,
      },
      headers,
    )
  },
})

export default propertiesApi
